
export class BasicAccountInfo {

  userId: number;
  FirstName: string;
  LastName: string;
  Authenticated: boolean;
  IsGuestLogin: boolean;
  Dob: Date;
  MiddleName: string;
  PrimaryResourceId: number;
  PrimaryResourceName: string;
  LastLoginDate: Date;
  GraduationYear: number;
  Grade: number;
  Username: string;

  constructor(userId: number, FirstName: string, LastName: string, authenticated: boolean, isGuestLogin: boolean, Dob: Date, MiddleName: string) {
    this.userId = userId;
    this.FirstName = FirstName;
    this.LastName = LastName;
    this.Authenticated = authenticated;
    this.IsGuestLogin = isGuestLogin;
    this.Dob = Dob;
    this.MiddleName = MiddleName;
  }
}

